<template>
    <modal
        v-if="open"
        root-id="trialPlansModal"
        root-classes="modal show"
        modal-width="modal-2xl"
        :ignore-escape="false"
    >
        <template #modal-close>
            <div class="modal-close-container">
                <button type="button" class="modal-close" data-miss="#trialPlansModal" @click="closeModal">
                    <svg
                        width="25"
                        xmlns="http://www.w3.org/2000/svg"
                        stroke="currentColor"
                        fill="none"
                        viewBox="0 0 24 24"
                        role="img"
                        aria-label="Icono para cerrar mensaje"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M6 18L18 6M6 6l12 12"
                        />
                    </svg>
                </button>
            </div>
        </template>

        <template #modal-container>
            <div class="modal-container">
                <div v-if="!plansAreVisible">
                    <img src="/images/icon-cup.png" class="mx-auto h-32 md:h-40" alt="Icono de premio">
                    <div class="sm:w-4/5 mx-auto">
                        <h6 class="text-2xl md:text-3xl font-semibold leading-tight text-center">Tu membresía, tus beneficios, gana con cada compra</h6>
                    </div>
                    <div class="grid sm:grid-cols-3 sm:divide-x sm:divide-solid sm:divide-gray-300 sm:mt-5">
                        <div class="col-span-1 text-center px-3 py-3 sm:py-5">
                            <img src="/images/emails/step-1.png" class="inline-block mx-auto max-w-full h-10" alt="Descuentos">
                            <p class="sm:text-sm text-gray-600 mt-2">Descuentos exclusivos en tiendas y restaurantes.</p>
                        </div>
                        <div class="col-span-1 text-center px-3 py-3 sm:py-5">
                            <img src="/images/emails/trial-3.png" class="inline-block mx-auto max-w-full h-10" alt="Invitaciones">
                            <p class="sm:text-sm text-gray-600 mt-2">Invitaciones a preventas exclusivas.</p>
                        </div>
                        <div class="col-span-1 text-center px-3 py-3 sm:py-5">
                            <img src="/images/emails/trial-1.png" class="inline-block mx-auto max-w-full h-10" alt="Bonificación">
                            <p class="sm:text-sm text-gray-600 mt-2">Bonificación del 10% en tu primera compra, y 5% en las siguientes.</p>
                        </div>
                    </div>
                    <img src="/images/modal-trial-banner.png" class="w-full rounded-md mt-5" alt="Promoción de Sanborns">

                    <div class="flex justify-center mt-6">
                        <a href="#" @click.prevent="showPlans" class="inline-block px-12 py-3 btn btn-blue">Ver planes</a>
                    </div>
                    <div class="mt-5">
                        <p class="text-center">Obtén el máximo en tus compras con Círculo Plus y aprovecha promociones exclusivas y contenido eligiendo alguno de nuestros planes.</p>
                    </div>
                </div>

                <div v-if="plansAreVisible">
                    <h6 class="mt-5 text-2xl md:text-3xl font-semibold leading-tight text-center">Todos los beneficios exclusivos con</h6>
                    <svg class="block mx-auto md:h-11 h-9 mt-3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 627.89 177.82">
                        <circle fill="#E1251B" cx="581.35" cy="46.54" r="46.54"/>
                        <path fill="#E1251B" d="M567.54 125.76a26.17 26.17 0 0 0-8.83-19.6 26.14 26.14 0 0 0-43.45 19.6v1a26.14 26.14 0 0 0 49.63 10.43 26 26 0 0 0 2.6-10.17c.04-.41.05-.83.05-1.26ZM505.22 156.54a21.27 21.27 0 0 0-.68-5.33 21 21 0 0 0-4.32-8.37 20.34 20.34 0 0 0-2.2-2.25 21.29 21.29 0 0 0-32.62 5.48 21.71 21.71 0 0 0-1.4 3.13 21.26 21.26 0 0 0-1.3 7.34v.82a21.29 21.29 0 0 0 40.41 8.49 21.11 21.11 0 0 0 2.11-8.28c-.01-.34 0-.68 0-1.03ZM445.29 155.52a17.67 17.67 0 0 0-4.18-11.46 18.25 18.25 0 0 0-1.84-1.89 17.8 17.8 0 0 0-27.27 4.59 17.31 17.31 0 0 0-1.21 2.62 17.59 17.59 0 0 0-1.09 6.14v.69a17.81 17.81 0 0 0 33.81 7.1 17.7 17.7 0 0 0 1.77-6.93c0-.28.01-.57.01-.86ZM397.71 136.53a15.74 15.74 0 0 0-.48-3.85 15.41 15.41 0 0 0-3.13-6.05 15.11 15.11 0 0 0-1.58-1.62A15.38 15.38 0 0 0 369 129a16.4 16.4 0 0 0-1 2.25 15.33 15.33 0 0 0-.94 5.31v.59a15.38 15.38 0 0 0 29.19 6.13 15.36 15.36 0 0 0 1.52-6c-.06-.28-.06-.5-.06-.75ZM368.5 108a11.68 11.68 0 0 0-2.74-7.52 12.78 12.78 0 0 0-1.21-1.23 11.71 11.71 0 0 0-4.55-2.51 11.3 11.3 0 0 0-3.2-.45 11.68 11.68 0 0 0-10.18 5.94 10.6 10.6 0 0 0-.79 1.71 11.51 11.51 0 0 0-.72 4v.45a11.69 11.69 0 0 0 22.18 4.67 11.33 11.33 0 0 0 1.16-4.54c.04-.17.05-.36.05-.52Z"/>
                        <path d="M38.38 85.59q-16.64 0-27.5-11A36.7 36.7 0 0 1 0 47.73a36.7 36.7 0 0 1 10.88-26.87q10.86-11 27.5-11A36.74 36.74 0 0 1 57 14.74a34.06 34.06 0 0 1 13.06 13.13l-6.48 3.76A26 26 0 0 0 53.33 21a29.08 29.08 0 0 0-14.95-4Q24.67 17 16 25.88a30 30 0 0 0-8.68 21.85A30.07 30.07 0 0 0 16 69.59q8.67 8.88 22.38 8.88a29.08 29.08 0 0 0 14.95-4 26 26 0 0 0 10.25-10.63l6.48 3.66A33.56 33.56 0 0 1 57 80.67a36.66 36.66 0 0 1-18.62 4.92ZM81 84.33V32.05h6.9v52.28Zm.31-59.6H88l7-13.6h-8.42ZM109.48 40.73q4.81-9.52 16.52-9.52v6.69a17.1 17.1 0 0 0-11.81 4.19c-3.14 2.78-4.71 7.18-4.71 13.17v29.07h-6.9V32.05h6.9ZM156.64 85.59a26.89 26.89 0 0 1-27.5-27.4 26.56 26.56 0 0 1 7.86-19.5q7.85-7.9 19.66-7.9a26.37 26.37 0 0 1 13.9 3.72 22 22 0 0 1 9 10l-5.65 3.24a16.21 16.21 0 0 0-6.74-7.47 20.15 20.15 0 0 0-10.51-2.77 19.79 19.79 0 0 0-14.64 6 20.08 20.08 0 0 0-6 14.69 20.08 20.08 0 0 0 6 14.69 20.31 20.31 0 0 0 32.31-4.23l5.73 3.34a24.15 24.15 0 0 1-9.52 9.94 27.16 27.16 0 0 1-13.9 3.65ZM226.8 32.05h6.9v52.28h-6.9v-8.16q-5.85 9.42-17.57 9.42-9.51 0-15-5.81t-5.49-15.63v-32.1h6.9v32.1q0 7 3.71 10.87t10.51 3.87a16.43 16.43 0 0 0 12.23-4.75q4.71-4.77 4.71-14.7ZM248.34 84.33V8h6.9v76.33ZM313.74 77.69a28 28 0 0 1-39 0 26.32 26.32 0 0 1-8-19.5 26.32 26.32 0 0 1 8-19.5 28 28 0 0 1 39 0 26.28 26.28 0 0 1 8 19.5 26.28 26.28 0 0 1-8 19.5Zm-34.14-4.81a20.84 20.84 0 0 0 29.28 0 20 20 0 0 0 6-14.69 20 20 0 0 0-6-14.69 20.84 20.84 0 0 0-29.28 0 20.08 20.08 0 0 0-6 14.69 20.08 20.08 0 0 0 6 14.69ZM360 11.13a24.36 24.36 0 0 1 17.78 7.12A23.56 23.56 0 0 1 385 35.71a23.56 23.56 0 0 1-7.21 17.46A24.35 24.35 0 0 1 360 60.28h-12.85v24h-14.43V11.13Zm0 35.66a10.1 10.1 0 0 0 7.64-3.19 11 11 0 0 0 3-7.89 11 11 0 0 0-3-7.95 10.2 10.2 0 0 0-7.64-3.14h-12.85v22.17ZM393.79 84.33V8h13.49v76.33ZM454.12 32.05h13.49v52.28h-13.49v-5.86q-4.92 7.32-15.58 7.32A18.9 18.9 0 0 1 424.37 80q-5.6-5.75-5.59-15.89V32.05h13.49v30.43q0 5.22 2.82 8a10.31 10.31 0 0 0 7.53 2.77A11.07 11.07 0 0 0 451 70q3.13-3.24 3.14-9.72ZM492 46.9c0 1.39.93 2.52 2.77 3.4a37.78 37.78 0 0 0 6.75 2.3 68.63 68.63 0 0 1 7.94 2.5 15.54 15.54 0 0 1 6.75 5.08 14 14 0 0 1 2.79 8.88q0 8.06-6 12.39t-15 4.34q-16.1 0-22-12.44l11.72-6.59q2.3 6.81 10.24 6.8 7.21 0 7.22-4.5c0-1.39-.93-2.52-2.77-3.39a40 40 0 0 0-6.75-2.36 69.44 69.44 0 0 1-7.94-2.61 16.35 16.35 0 0 1-6.75-5 13 13 0 0 1-2.77-8.52A14.6 14.6 0 0 1 483.87 35 22.36 22.36 0 0 1 498 30.58a23.62 23.62 0 0 1 11.6 2.88 21 21 0 0 1 8.26 8.21l-11.5 6.27a8.6 8.6 0 0 0-8.36-5.33 7.62 7.62 0 0 0-4.34 1.15A3.59 3.59 0 0 0 492 46.9Z"/>
                        <path fill="#FFFFFF" d="M582.18 76.8q-8.89 0-14.83-3.86a21 21 0 0 1-8.44-10.52l11.47-6.65q3.5 8.07 12.22 8.06 7.9 0 7.9-4.74a4.48 4.48 0 0 0-2.54-4 46.06 46.06 0 0 0-9.52-3.36 43.35 43.35 0 0 1-6.4-2.25 26.73 26.73 0 0 1-5.36-3.28 13.06 13.06 0 0 1-4-5.12 17.23 17.23 0 0 1-1.36-7.08 15.92 15.92 0 0 1 5.78-12.9 20.78 20.78 0 0 1 13.75-4.82 23.63 23.63 0 0 1 12.64 3.37 23.1 23.1 0 0 1 8.65 9.77L590.91 36a13 13 0 0 0-3.9-5 10.26 10.26 0 0 0-6.16-1.7 7.25 7.25 0 0 0-4.61 1.29 3.87 3.87 0 0 0-1.62 3.12 4.64 4.64 0 0 0 2 3.74c1.35 1.05 4.17 2.21 8.43 3.49q3.49 1.08 5.41 1.74a39.33 39.33 0 0 1 4.86 2.21 15.77 15.77 0 0 1 4.49 3.24 16.17 16.17 0 0 1 2.74 4.49 15.79 15.79 0 0 1 1.21 6.36q0 8.31-6 13.09t-15.58 4.73Z"/>
                    </svg>
                    <img src="/images/modal-trial-banner.png" class="w-full rounded-md mt-5" alt="Promoción de Sanborns">
                    <h6 class="mt-5 md:mt-10 text-2xl md:text-3xl font-semibold leading-tight text-center">Elige un plan</h6>
                    <p class="text-center mt-3">Obtén el máximo en tus compras con Círculo Plus y aprovecha promociones exclusivas y contenido eligiendo alguno de nuestros planes.</p>
                    <div class="col-span-12 lg:col-span-8 mt-8">
                        <plans
                            root-classes="grid grid-cols-1 sm:grid-cols-12 sm:gap-6 gap-10"
                            loop-classes="sm:col-span-6"
                            section="activation-modal"
                            @bubbleUpPlanSelected="planWasSelectedListener"
                        ></plans>
                    </div>

                    <div class="relative flex items-start justify-center mt-5">
                        <div class="flex h-6 items-center mr-2">
                            <input id="terms" aria-describedby="terms" name="terms" type="checkbox" class="h-4 w-4 form-checkbox text-green-500 focus:shadow-none cursor-pointer" @click="toggleTerms" required>
                        </div>
                        <label for="terms" class="text-sm">Acepto los <a href="https://circulo.plus/legales/terminos-y-condiciones?utm_source=footer&utm_medium=link" class="text-blue-500 underline" target="_blank" rel="noopener noreferrer nofollow">Términos y condiciones</a> y <a href="https://circulo.plus/legales/aviso-de-privacidad?utm_source=footer&utm_medium=link" class="text-blue-500 underline inline-block" target="_blank" rel="noopener noreferrer nofollow">Aviso de privacidad</a> de <strong>Círculo Plus.</strong></label>
                    </div>

                    <div class="flex justify-center">
                        <a href="#" @click="finishStep" id="accept-membership" class="flex md:px-8 px-4 py-4 btn btn-green leading-tight mt-5" :class="{ disabled: submitIsDisabled }">Activar membresía</a>
                    </div>
                </div>
            </div>
        </template>
    </modal>
</template>
<script>
import Modal from './Modal';
import Plans from './Plans';
import Form from '../support/Form';

export default {
    components: {
        Modal,
        Plans
    },

    props: ['userShouldSeePlans'],

    data() {
        return {
            open: true,
            plansAreVisible: this.userShouldSeePlans,
            plan: null,
            form: new Form({
                plan_id: null,
                terms_accepted: false,
                user_should_see_plans: this.userShouldSeePlans,
            }),
            submitIsDisabled: true
        };
    },

    methods: {
        toggleTerms() {
            this.form.terms_accepted = ! this.form.terms_accepted
            this.submitIsDisabled = !this.form.terms_accepted || !this.form.plan_id
        },

        closeModal() {
            $('body, html').removeClass('overflow-hidden');

            this.open = false;
        },

        planWasSelectedListener(plan) {
            this.plan = plan
            this.form.plan_id = plan.id
            this.submitIsDisabled = !this.form.terms_accepted || !this.form.plan_id
        },

        showPlans() {
            this.form.user_should_see_plans = true
            this.form.post('suscripcion/plan').then(() =>
                this.plansAreVisible = true
            )
        },

        finishStep() {
            const plan_id = this.form.plan_id
            this.form.post('/suscripcion/plan').then(() =>
                this.$emit('planChosen', this.plan)
            )
        }
    },
};
</script>
